import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import {connect} from 'react-redux'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {userSignOut} from '../../../external/actions/Auth';
import { Principal,PrincipalChanged } from '../../../auth';
import { DeviceEventEmitter } from 'codeArt/components/Base';

class UserInfo extends React.Component {

 
  constructor(props) {
    super(props);
    this.state = {
      authUser: Principal.current().data
    }
  }

  handleClick = event => {
    let {passage} = this.props; 
    if(passage) passage(event);
  };

  // handleRequestClose = () => {
  //   this.setState({open: false});
  // };

  // userSignOut(){
  //   let {initURL,history} = this.props;
  //   Principal.signOut();
  //   history.push(initURL);
  // }

  addEventable() {
    this._broadcastEvent = DeviceEventEmitter.addListener('broadcastEvent', (arg) => { this.on(arg); });
  }

  removeEventable() {
    if (this._broadcastEvent) this._broadcastEvent.remove();
  }

  componentDidMount() {
    
  }

  on(arg){
    let my = this;
    if(arg.source == PrincipalChanged){
      my.setState({
        authUser: Principal.current().data
      });
      return;
    }
  }

  componentWillMount(){
      this.addEventable();
  }

  componentWillUnmount(){
      this.removeEventable();
  }

  render() {
    let {authUser} = this.state;
    let {passage} = this.props;
    let name = authUser.RealName||authUser.Name;
    return (
      <div className="user-profile d-flex flex-row align-items-center">
        <Avatar
          alt={name}
          src={authUser.Photo}
          className="user-avatar "
        />
        <div className="user-detail">
          <h4 className="user-name c-mb-0" onClick={this.handleClick}>
            {name}
            {passage?<i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>:null}
          </h4>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({settings}) => {
  const {locale} = settings;
  return {locale}
};
export default connect(mapStateToProps, {userSignOut})(UserInfo);


